import { render, staticRenderFns } from "./NewBookingsAlert.vue?vue&type=template&id=29a1b424&scoped=true&"
import script from "./NewBookingsAlert.vue?vue&type=script&lang=js&"
export * from "./NewBookingsAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewBookingsAlert.vue?vue&type=style&index=0&id=29a1b424&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1b424",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
